import { Types } from "../actions/importadorProductos";
import { IImportadorProductosState } from "../pages/importadorProductos/interface/IImportadorProductos";

const defaultState: IImportadorProductosState = {
  loading: false,
  loadingDownload: false,
  success: false,
  error: false,
  errorMessage: undefined,
  productosEncontrados: [],
  productosNoEncontrados: [],
  successMessage: undefined,
};

export default function importadorProductosReducer(
  state = defaultState,
  action: any,
): IImportadorProductosState {
  switch (action.type) {
    case Types.IMPORTADOR_LOADING:
      return { ...state, loading: true, error: false };

    case Types.IMPORTADOR_LOADING_DOWNLOAD:
      return { ...state, loadingDownload: true, error: false };

    case Types.DESCARGAR_TEMPLATE_SUCCEEDED:
      return { ...state, loadingDownload: false };

    case Types.DESCARGAR_TEMPLATE_ERROR:
      return {
        ...state,
        loadingDownload: false,
        error: true,
        errorMessage: action.err?.message || "Error descargando template",
      };

    case Types.IMPORTAR_PRODUCTOS_SUCCEEDED:
      return {
        ...state,
        loading: false,
        success: true,
        productosEncontrados: action.productosEncontrados,
        productosNoEncontrados: action.productosNoEncontrados,
        error: false,
      };

    case Types.IMPORTAR_PRODUCTOS_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        errorMessage: action.err?.message || "Error importando productos",
        productosEncontrados: [],
        productosNoEncontrados: [],
      };

    case Types.CONFIRMAR_IMPORTACION_SUCCEEDED:
      return {
        ...state,
        loading: false,
        success: true,
        successMessage: action.successMessage,
        error: false,
      };

    case Types.CONFIRMAR_IMPORTACION_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        errorMessage: action.err?.message || "Error confirmando importación",
      };

    case Types.LIMPIAR_ESTADO:
      return defaultState;

    default:
      return state;
  }
}
